import React, { useState, useEffect } from 'react';
import { motion } from 'motion/react';
import CyberLoader from '../common/CyberLoader';
import '../dashboard/Dashboard.css';

export default function AdminDashboard({ onBack }) {
  const [inviteCode, setInviteCode] = useState('');
  const [newInviteCode, setNewInviteCode] = useState('');
  const [updatingCode, setUpdatingCode] = useState(false);
  const [codeMessage, setCodeMessage] = useState('');

  const [users, setUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(true);
  
  const [selectedUser, setSelectedUser] = useState(null);
  const [resetMessage, setResetMessage] = useState('');

  useEffect(() => {
    const fetchAdminData = async () => {
      const baseUrl = process.env.REACT_APP_BACKEND_URL || '';
      const token = localStorage.getItem('vault_jwt');
      try {
        // Fetch Invite Code
        const inviteResp = await fetch(`${baseUrl}/api/admin/invite-code`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (inviteResp.ok) {
          const data = await inviteResp.json();
          setInviteCode(data.code);
        }

        // Fetch Users
        const usersResp = await fetch(`${baseUrl}/api/admin/users`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (usersResp.ok) {
          const uData = await usersResp.json();
          setUsers(uData || []);
        }
      } catch (e) {}
      setLoadingUsers(false);
    };

    fetchAdminData();
  }, []);

  const handleUpdateCode = async (e) => {
    e.preventDefault();
    setUpdatingCode(true);
    setCodeMessage('');
    const baseUrl = process.env.REACT_APP_BACKEND_URL || '';
    const token = localStorage.getItem('vault_jwt');
    try {
      const resp = await fetch(`${baseUrl}/api/admin/invite-code`, {
        method: 'POST',
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ code: newInviteCode })
      });
      if (resp.ok) {
        setInviteCode(newInviteCode);
        setNewInviteCode('');
        setCodeMessage('Invite code updated successfully.');
      } else {
        setCodeMessage('Failed to update code.');
      }
    } catch (e) {
      setCodeMessage('Network error.');
    }
    setUpdatingCode(false);
  };

  const handleResetPassword = async () => {
    if (!selectedUser) return;
    if (!window.confirm(`Are you sure you want to reset the password for ${selectedUser.username}?`)) {
      return;
    }

    setResetMessage('Resetting...');
    const baseUrl = process.env.REACT_APP_BACKEND_URL || '';
    const token = localStorage.getItem('vault_jwt');
    
    try {
      const resp = await fetch(`${baseUrl}/api/admin/reset-password`, {
        method: 'POST',
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ username: selectedUser.username })
      });
      if (resp.ok) {
        setResetMessage(`Password for ${selectedUser.username} was successfully reset to: gamershub123`);
        setSelectedUser(null);
      } else {
        setResetMessage(`Failed to reset password for ${selectedUser.username}.`);
      }
    } catch (e) {
      setResetMessage('Network error during reset.');
    }
  };

  return (
    <div className="dashboard-screen">
      <div className="dashboard-header">
        <button className="btn btn-primary back-btn" onClick={onBack} style={{ width: 'auto' }}>
           Back to Lobby
        </button>
      </div>

      <motion.div 
        className="dashboard-content"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
      >
        <div className="dashboard-card admin-card">
          <h2>Admin Dashboard</h2>
          
          <div className="admin-section" style={{ marginBottom: '30px' }}>
            <h3>Invite Code Management</h3>
            <div className="admin-current-code">
              Current Invite Code: <span className="highlight-code">{inviteCode}</span>
            </div>
            <form onSubmit={handleUpdateCode} className="admin-form">
              <input 
                type="text" 
                placeholder="New Invite Code" 
                value={newInviteCode}
                onChange={e => setNewInviteCode(e.target.value)}
                required
              />
              <button type="submit" className="btn btn-primary" disabled={updatingCode}>
                {updatingCode ? 'Updating...' : 'Update Code'}
              </button>
            </form>
            {codeMessage && <div className="admin-msg">{codeMessage}</div>}
          </div>

          <div className="admin-section">
            <h3>Player Profiles</h3>
            {loadingUsers ? (
              <CyberLoader />
            ) : (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', textAlign: 'left', borderCollapse: 'collapse', marginTop: '10px' }}>
                  <thead>
                    <tr style={{ borderBottom: '1px solid #444' }}>
                      <th style={{ padding: '8px' }}>ID</th>
                      <th style={{ padding: '8px' }}>Username</th>
                      <th style={{ padding: '8px' }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map(u => (
                      <tr key={u.id} style={{ borderBottom: '1px solid #222' }}>
                        <td style={{ padding: '8px' }}>{u.id}</td>
                        <td style={{ padding: '8px' }}>{u.username}</td>
                        <td style={{ padding: '8px' }}>
                          <button 
                            className="btn btn-secondary"
                            style={{ padding: '4px 10px', fontSize: '0.9em', width: 'auto' }}
                            onClick={() => setSelectedUser(u)}
                          >
                            Reset Password
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            
            {selectedUser && (
              <div style={{ marginTop: '20px', padding: '15px', border: '1px solid #f00', borderRadius: '8px', backgroundColor: 'rgba(255,0,0,0.1)' }}>
                <p>Selected User: <strong>{selectedUser.username}</strong></p>
                <button className="btn btn-primary" onClick={handleResetPassword} style={{ width: 'auto', backgroundColor: '#f00' }}>
                  Confirm Reset Password
                </button>
                <button className="btn btn-secondary" onClick={() => setSelectedUser(null)} style={{ width: 'auto', marginLeft: '10px' }}>
                  Cancel
                </button>
              </div>
            )}
            {resetMessage && <div className="admin-msg" style={{ marginTop: '15px', color: '#0f0' }}>{resetMessage}</div>}
          </div>

        </div>
      </motion.div>
    </div>
  );
}
